import script from "./GridUsersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridUsersComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridUsersComponent.vue?vue&type=style&index=0&id=71b7b63d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b7b63d"]])

export default __exports__